import { FormInstance, Rule } from 'antd/lib/form';

export const formValidation = (form: FormInstance, nonRequiredList: string[], includesList?: string[]): boolean => {
  // field error 체크

  if (!!form.getFieldsError().filter(({ errors }) => errors.length).length) {
    return false;
  } else {
    const isRequired = (field: string) => {
      const value = form.getFieldValue(field);

      if (typeof value === 'number') {
        return true;
      } else {
        return !!value;
      }
    };

    const allFields = form.getFieldsValue();
    let allRequiredFields = Object.keys(allFields);

    // form fields 중 required field만 필터링
    nonRequiredList.forEach((fieldName: string) => {
      allRequiredFields = allRequiredFields.filter((field) => field !== fieldName);
      
    });
    if (includesList) {
      for (let i = 0; i < includesList.length; i++) {
        allRequiredFields = allRequiredFields.filter((field) => !field.includes(includesList[i]));
      }
    }

    for (let i = 0; i < allRequiredFields?.length; i++) {
      const fieldName = allRequiredFields[i];

      if (!isRequired(fieldName)) {
        return false;
      }
    }
  }

  return true;
};

export const onlyKoreanRegexRule = (label: string): Rule => {
  return {
    pattern: /[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g,
    message: `${label} 한글만 사용 가능합니다.`,
  };
};

export const engNumRegexRule = (label: string): Rule => {
  return {
    pattern: /^[a-zA-Z0-9]*$/,
    message: `${label} 영문, 숫자만 사용 가능합니다.`,
  };
};
export const requiredRule = (label: string): Rule => {
  return {
    required: true,
    message: `${label} 입력해주세요`,
  };
};

export const numHyphenRegexRule = (label: string): Rule => {
  return {
    pattern: /^[0-9\-]*$/,
    message: `${label} 숫자, 하이폰(-)만 사용 가능합니다.`,
  };
};

export const maxRule = (max: number): Rule => {
  return {
    max,
    message: `${max}자 이내로 작성해 주세요.`,
  };
};
export const emailRule = (): Rule => {
  return {
    type: 'email',
    message: '형식이 올바르지 않습니다.',
  };
};

export const contactRule = (): Rule => {
  return {
    pattern: /^[0-9]*$/,
    message: '형식이 올바르지 않습니다.',
  };
};

export const youtubeLinkRule = (): Rule => {
  return {
    pattern: /youtube.com/,
    message: '유튜브 링크만 첨부 가능합니다',
  };
};

export const passwordRule = (label: string): Rule => {
  return {
    pattern: /^[^가-힣ㄱ-ㅎㅏ-ㅣ\s]*$/g,

    message: `${label} 영문, 숫자, 툭수문자만 사용 가능합니다.`,
  };
};

export const minRule = (min: number): Rule => {
  return {
    min,
    message: `${min}자 이상 작성해 주세요.`,
  };
};

export const phoneRule = (): Rule => {
  return {
    pattern: /^[0-9]{2,3}[-]+[0-9]{3,4}[-]+[0-9]{3,4}$/,
    message: '형식이 올바르지 않습니다.',
  };
};

export const faxRule = (): Rule => {
  return {
    pattern: /^[0-9]{0,10}[-]+[0-9]{0,10}[-]+[0-9]{0,10}$/,
    message: '형식이 올바르지 않습니다.',
  };
};

export const protocolRule = (): Rule => {
  return {
    pattern: /^https?:\/\//,
    message: 'http:// 또는 https://로 시작해야 합니다.',
  };
};

export const selectBoxFilterOption = (input: string, option?: any) =>
(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export const selectBoxFilterOption2 = (input: string, option?: any) =>
(option?.caption ?? '').toLowerCase().includes(input.toLowerCase());

export function getCodeArray(value?: string, max?: number) {
  return value
    ? value
        .split(',')
        .filter((code) => code)
        .slice(0, max)
    : [];
}

export function getCodeNumberArray(value?: string, max?: number) {
  return value
    ? value
        .split(',')        
        .filter((code) => code)
        .slice(0, max)
        .map((value) => Number(value))
    : [];
    
}

export const makeMaskPhoneNumber = (value: string): string => {
  let phone = value.replace(/[^0-9]/g, '');
  const arr = ['', '', ''];
  if (phone.length < 2) {
      arr[0] = phone;
  } else if (phone.startsWith('02')) {
      arr[0] = phone.substring(0, 2);
      if (phone.length < 10) {       
          arr[1] = phone.substring(2, 5);
          arr[2] = phone.substring(5, 10);
      } else {
          arr[1] = phone.substring(2, 6);
          arr[2] = phone.substring(6, 10);                
      } 
  } else {
      arr[0] = phone.substring(0, 3);

      if (phone.startsWith('01') || phone.length > 10) {
          arr[1] = phone.substring(3, 7);
          arr[2] = phone.substring(7, 11);
      } else {
          arr[1] = phone.substring(3, 6);
          arr[2] = phone.substring(6, 10);
      }
  }

  phone = arr[0];
  if (arr[1] !== '') phone += '-'+arr[1];
  if (arr[2] !== '') phone += '-'+arr[2];

  return phone;
}